import Image from 'next/image';
import { useMemo } from 'react';
import { Heading } from 'ui-components';
import { AgeBarChart } from '~/screens/CreatorAudienceDemographics/AgeDistribution';
import {
  DistributionProps,
  colorFemale,
  useInsights,
} from '~/screens/CreatorAudienceDemographics/GenderDistribution';

import PlaceholderAge from '../static/age.png';

export const AgeDistribution = ({
  insightId,
  platform,
  isConnected,
}: DistributionProps) => {
  const insights = useInsights({ insightId, platform });

  const ageData = useMemo(() => {
    const ages = insights?.data?.ages;
    const labels = ages?.map((age) => age.label) || [];
    const values = ages?.map((age) => Math.round(age.value * 100)) || [];
    return {
      labels,
      datasets: [
        {
          label: 'Age',
          data: values,
          backgroundColor: colorFemale,
          borderColor: '#fff',
          borderWidth: 2,
        },
      ],
    };
  }, [insights?.data?.ages]);

  if (!isConnected) {
    return <Image src={PlaceholderAge} alt="age distribution" />;
  }

  return (
    <>
      <Heading size="sm">Age distribution</Heading>
      <AgeBarChart data={ageData} />
    </>
  );
};
